import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'reactstrap';
import PropertyForm from './PropertyForm';
import { addProperty } from 'store/slices/personalSlice';
import { connect } from 'react-redux';

const NewProperty = ({
  property,
  addProperty
}) => {
  const {
    t
  } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const initValue = () => {
    if (property.fields) {
      // Initialize with empty fields for complex properties
      const fields = {};
      Object.entries(property.fields).forEach(([key, field]) => {
        // Skip empty keys to avoid React warnings
        if (key !== '' && key != null) {
          fields[key] = { ...field,
            value: ''
          };
        }
      });
      return fields;
    }

    return '';
  };

  const onSubmit = (name, value) => {
    return addProperty(name, value).then(() => {
      if (isMounted.current) {
        setShowForm(false);
      }
    });
  };

  const closeForm = () => setShowForm(false);

  if (showForm) {
    return <PropertyForm initValue={initValue()} property={property} onSubmit={onSubmit} closeForm={closeForm} />;
  }

  return <Button color="outline-primary" size="sm" onClick={() => setShowForm(true)}>{t("+ Add")}{property.showName}
    </Button>;
};

const mapDispatchToProps = dispatch => ({
  addProperty: (name, value) => dispatch(addProperty(name, value))
});

export default connect(null, mapDispatchToProps)(NewProperty);